export const DASHBOARD_ROUTES = [
    {
        title: 'Настройки профиля',
        pathname: '/my-profile',
    },
    {
        title: 'Экзамены',
        pathname: [
            '/exam-timetables',
            '/exam-in-progress',
            '/exam/*',
            '/exam-application-details/*',
            '/participation-requests',
            '/application-exam-details/*',
            '/exam-list',
            '/soviet-protocols',
        ],
    },
    {
        title: 'ЭЦ',
        pathname: '/connected-ec',
    },
    {
        title: 'Квалификации',
        pathname: ['/expert-qualifications', '/expert-certificate', '/qualification-detail/*'],
    },
    {
        title: 'Регистрация',
        pathname: ['/registration-completion'],
    },
];
